import {ShieldLockIcon} from '@primer/octicons-react'
import {Tooltip} from '@github-ui/pacer/Tooltip'

import styles from './RestrictionShield.module.css'

/**
 * Accessible label announced on an owner-scope restriction shield. Names the
 * owner whose private repositories the surface is scoped to.
 *
 * Keep this text in sync with the identical helper in
 * `@github-ui/repos-selector` (ReposSelector.tsx) — both surfaces share the
 * github-ui#31409 restriction-shield design contract.
 */
export function restrictionShieldLabel(owner: string): string {
  return `Private repository selection is restricted to ${owner}.`
}

/**
 * Shield shown beside a repo-reference menu heading when an owner scope is
 * active. Hovering or focusing the shield reveals the restriction text, which
 * is also its accessible name.
 */
export function RestrictionShield({owner}: {owner: string}) {
  const label = restrictionShieldLabel(owner)

  return (
    <Tooltip text={label} relationship="label">
      <span role="img" data-testid="reference-restriction-shield" className={styles.restrictionShield}>
        <ShieldLockIcon aria-hidden="true" size={16} />
      </span>
    </Tooltip>
  )
}
